import { IngredientFragment } from '@repo/ui/src/graphql/fragments';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import useSWRImmutable from 'swr/immutable';
import { gql } from 'graphql-request';
import { GraphQLRequestProps, request } from '@utils/graphql-request';

export const getRecipeBySlotId = gql`
  query GetRecipeBySlotId($slotId: String!) {
    getRecipeBySlotId(slotId: $slotId) {
      servingSizes {
        people
        ingredientSummary {
          groups {
            groupKey
            groupName
            ingredients {
              ...Ingredient
            }
          }
          hasMetric
          hasImperial
        }
        steps {
          instruction
          assets {
            name
            endpoint
          }
          youtubeLink {
            name
            contentUrl
          }
          cookCycleInfo {
            grillTemp
            probeTarget
            superSmoke
            probeTargetTemperature {
              fahrenheit
              celsius
            }
            grillTemperature {
              fahrenheit
              celsius
            }
          }
          Ingredients {
            ...Ingredient
          }
        }
      }
    }
  }
  ${IngredientFragment}
`;

interface Key extends GraphQLRequestProps {
  id?: string;
}

const fetcher = async ({ id, ...props }: Key) => {
  if (!id) {
    return;
  }
  const { getRecipeBySlotId } = await request({
    ...props,
    variables: {
      slotId: id,
    },
  });
  return getRecipeBySlotId.servingSizes;
};

export const useServingSize = (id?: string) => {
  const { locale } = useCurrentUrl();
  return useSWRImmutable({ document: getRecipeBySlotId, locale, id }, fetcher, {
    revalidateOnMount: false,
  });
};

export default useServingSize;
